/**
 * Единый формат URL для истории навигации по Библии:
 * - без query/hash
 * - без хвоста /parallel, /interpretation, /image (это режимы экрана, не отдельные «места»)
 * - bookId / chapter / verse — без ведущих нулей
 */

const MODAL_SUFFIXES = new Set(['parallel', 'interpretation', 'image']);

/**
 * @param {string} url
 * @returns {string}
 */
export function normalizeBibleHistoryPath(url) {
  if (url == null || typeof url !== 'string') return '/';
  const pathOnly = url.split('?')[0].split('#')[0];
  let segments = pathOnly.split('/').filter(Boolean);
  if (segments.length === 0) return '/';

  while (segments.length > 0 && MODAL_SUFFIXES.has(segments[segments.length - 1])) {
    segments = segments.slice(0, -1);
  }

  const out = [];
  for (let i = 0; i < segments.length; i++) {
    const s = segments[i];
    if (i === 0) {
      out.push(s);
      continue;
    }
    const n = parseInt(s, 10);
    out.push(Number.isFinite(n) && !Number.isNaN(n) ? String(n) : s);
  }

  return '/' + out.join('/');
}

/**
 * Канонический путь для сохранения из ChapterView (всегда совпадает с normalize(location.pathname))
 * @param {{ translation: string, bookId?: string|number|null, chapter?: string|number|null, verse?: string|number|null }} p
 */
export function buildBibleHistoryPath({ translation, bookId, chapter, verse }) {
  const t = String(translation || 'kjv').trim();
  const parts = [t];

  if (bookId != null && bookId !== '') {
    const b = parseInt(bookId, 10);
    if (!Number.isNaN(b)) parts.push(String(b));
  }
  if (chapter != null && chapter !== '') {
    const c = parseInt(chapter, 10);
    if (!Number.isNaN(c)) parts.push(String(c));
  }
  if (verse != null && verse !== '') {
    const v = parseInt(verse, 10);
    if (!Number.isNaN(v)) parts.push(String(v));
  }

  return normalizeBibleHistoryPath('/' + parts.join('/'));
}
